const FilesIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2706_19065)">
        <path
          d="M14.175 2.175H9.325L8.9 1.35C8.65 0.9 8.2 0.625 7.675 0.625H3.925C3.175 0.625 2.55 1.25 2.55 2V3.2H1.825C1.075 3.2 0.449997 3.825 0.449997 4.575V13.95C0.449997 14.7 1.075 15.325 1.825 15.325H12.075C12.825 15.325 13.45 14.7 13.45 13.95V12.75H14.175C14.925 12.75 15.55 12.125 15.55 11.375V3.575C15.575 2.8 14.95 2.175 14.175 2.175ZM12.325 13.975C12.325 14.125 12.2 14.225 12.075 14.225H1.825C1.675 14.225 1.575 14.1 1.575 13.975V4.6C1.575 4.45 1.7 4.35 1.825 4.35H5.575C5.675 4.35 5.75 4.4 5.8 4.475L6.4 5.6C6.5 5.775 6.7 5.9 6.9 5.9H12.1C12.25 5.9 12.35 6.025 12.35 6.15V13.975H12.325ZM14.45 11.4C14.45 11.55 14.325 11.65 14.2 11.65H13.475V6.15C13.475 5.4 12.85 4.775 12.1 4.775H7.2L6.775 3.95C6.525 3.5 6.075 3.225 5.55 3.225H3.675V2.025C3.675 1.875 3.8 1.775 3.925 1.775H7.675C7.775 1.775 7.85 1.825 7.9 1.9L8.5 3C8.6 3.175 8.8 3.3 9 3.3H14.2C14.35 3.3 14.45 3.425 14.45 3.55V11.4Z"
          fill="#9CA3AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_2706_19065">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FilesIcon;
